<template>
  <div class="full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders/orderList' }">{{ $t("notFound.home") }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>FBA{{ $t("fba.packList") }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-collapse v-show="isActive">
            <el-row class="search-row">
              <el-col :span="6" class="display-row">
                <div class="query-title">{{ $t("fba.logisticsCompany") }}:</div>
                <div class="flex1">
                  <el-select v-model="queryInfo.logisticeCompany" :placeholder="$t('common.pleaseSelect')" size="small" clearable>
                    <el-option v-for="item in dropDownList" :key="item.id" :label="item.companyName" :value="item.companyName">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6" class="display-row">
                <div class="query-title">{{ $t("orderList.orderList4") }}:</div>
                <div class="flex1">
                  <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.waybillNumber" size="small" @keyup.enter.native="searchList">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="6" class="display-row">
                <div class="query-title">{{ $t("fba.line") }}:</div>
                <div class="flex1">
                  <el-select v-model="queryInfo.route" :placeholder="$t('common.pleaseSelect')" size="small" clearable>
                    <el-option v-for="item in routeList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6" class="display-row">
                <div class="query-title">{{ $t("fba.packBatchNo") }}:</div>
                <div class="flex1">
                  <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.containerBatchNo" size="small"
                    @keyup.enter.native="searchList">
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row class="search-row">
              <el-col :span="6" class="display-row">
                <div class="query-title">
                  {{ $t("common.createStartDate") }}:
                </div>
                <div class="flex1">
                  <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                    :placeholder="$t('common.selectDate')">
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="6" class="display-row">
                <div class="query-title">{{ $t("common.createEndDate") }}:</div>
                <div class="flex1">
                  <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                    :placeholder="$t('common.selectDate')">
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="6" class="display-row" v-if="isClientManage === '1'">
                <div class="query-title">{{ $t("cnumber.cnumber20") }}:</div>
                <div class="flex1">
                  <ChildCode v-model="queryInfo.customerId"></ChildCode>
                </div>
              </el-col>
              <el-col :span="6" style="margin-top: 5px;text-align: center">
                {{ $t("feedback.feedback21") }}
              </el-col>
            </el-row>
          </el-collapse>
          <div class="search-row" style="display: flex; justify-content: space-between">
            <div class="">
              <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 0 }"
                @click="quickSearchList('', (index = 0))">{{ $t("common.all") }}</el-button>
              <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 7 }" @click="quickSearchList('6', (index = 7))">{{ $t("fba.toPack")
                }}<span class="lx-red">({{ orderData.waitBoxNum }})</span>
              </el-button>
              <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 1 }" @click="quickSearchList('0', (index = 1))">{{ $t("fba.packing")
                }}<span class="lx-red">({{ orderData.boxingNum }})</span>
              </el-button>
              <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 8 }" @click="quickSearchList('7', (index = 8))">{{ $t("fba.finishBox")
                }}<span class="lx-red">({{ orderData.finishBoxNum }})</span></el-button>
              <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 2 }" @click="quickSearchList('1', (index = 2))">{{ $t("fba.toPay")
                }}<span class="lx-red">({{ orderData.waitPayNum }})</span>
              </el-button>
              <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 9 }" @click="quickSearchList('11', (index = 9))">
                {{ $t("goods.goods3") }}
                <span class="lx-red">({{ orderData.payWaitReviewNum }})</span>
              </el-button>
              <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 3 }" @click="quickSearchList('2', (index = 3))">{{ $t("fba.toUploadInvoice")
                }}<span class="lx-red">({{ orderData.waitVoiceNum }})</span></el-button>
              <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 4 }" @click="quickSearchList('3', (index = 4))">{{ $t("fba.toSend")
                }}<span class="lx-red">({{ orderData.waitSendNum }})</span></el-button>
              <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 5 }"
                @click="quickSearchList('4', (index = 5))">{{ $t("fba.sent") }}</el-button>
              <el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 6 }"
                @click="quickSearchList('5', (index = 6))">{{ $t("fba.cancelled") }}</el-button>
            </div>
            <!-- <el-col> </el-col> -->
            <div>
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{
                $t("common.reset")
              }}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{
                $t("common.search")
              }}</el-button>
              <el-button class="search-btn btn-green" @click="newBuiltOrder">{{
                $t("fba.createPackList")
              }}</el-button>
              <el-button class="search-btn btn-green" @click="toSort">{{
                $t("orderList.orderList156")
              }}</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt=""
                @click="isActive = !isActive">{{ $t("search.expandPanel") }}</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt=""
                @click="isActive = !isActive">{{ $t("search.retractPanel") }}</el-button>
            </div>
          </div>
        </el-row>
      </div>
      <!-- 内容 -->
      <div slot="table" class="lx-table-wrapper lx-flex-grow-1 lx-hidden lx-relative">
        <lx-table :showIndexCode="false" :list="containerList" border stripe :rowKey="'id'" :emptyText="$t('select.select24')" :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle">
          <el-table-column :show-overflow-tooltip="!['senderAddress', 'putIntent'].includes(item.key)" v-for="(item, index) in asyncColumns" :key="index" align="center" :label="item.name" :prop="item.key"
            :width="tableCellWidth(item.key) ? (tableCellWidth(item.key).width || 'auto') : 'auto'"
            :min-width="tableCellWidth(item.key) ? (tableCellWidth(item.key).minWidth || 'auto') :'auto'">
            <template v-slot="scope">
              <div v-if="item.key === 'handle'">
                <el-button class="list-btn btn-blue" @click="messageAdd(scope.row)">{{ $t("orderList.orderList23")
                }}</el-button>
                <div class="btn-row" v-if="scope.row.containerState != 6 &&
                  scope.row.containerState != 5
                  ">
                  <el-button class="list-btn-four btn-blue" @click="toContainerDetail(scope.row)">
                    {{ $t("fba.packDetail") }}</el-button>
                </div>
                <div class="btn-row">
                  <el-button class="list-btn-four btn-deepblue" @click="ContainerOrderList(scope.row)">
                    {{ $t("fba.packList") }}</el-button>
                </div>
                <div class="btn-row" v-if="scope.row.containerState == 1">
                  <el-button class="list-btn-four btn-red" @click="toOrderBillPay(scope.row)">{{ $t("fba.pay")
                  }}</el-button>
                </div>
                <div class="btn-row" v-if="scope.row.containerState != 0 &&
                  scope.row.containerState != 1 &&
                  scope.row.containerState != 6 &&
                  scope.row.containerState != 5 &&
                  scope.row.containerState != 7
                  ">
                  <el-button class="list-btn-four btn-green" @click="toOrderBill(scope.row)">{{ $t("fba.bill")
                  }}</el-button>
                </div>
                <div class="btn-row" v-if="scope.row.containerState == 6">
                  <el-button class="list-btn-four btn-red" @click="cannelBill(scope.row)">{{ $t("common.cancel")
                  }}</el-button>
                </div>
                <!-- <div class="btn-row" v-if="scope.row.customerBoxUrl">
                  <el-button class="list-btn  btn-deepblue"
                             @click="downloadUrl(scope.row.customerBoxUrl)">
                    {{ $t("fba.boxDownLoad") }}
                  </el-button>
                </div> -->
                <!-- <div class="btn-row" v-if="scope.row.customerBillUrl">
                  <el-button class="list-btn  btn-deepblue"
                             @click="downloadUrl(scope.row.customerBillUrl)">
                    {{ $t("fba.billDownLoad") }}
                  </el-button>
                </div> -->
              </div>
              <div v-else-if="item.key === 'containerBatchNo'">
                {{ scope.row.containerBatchNo }}
              </div>
              <div v-else-if="item.key === 'status'" class="lx-text-center">
                <p style="margin-bottom: 10px;">{{scope.$index + 1}}</p>
                <div v-for="(item, i) in containerStateList" :key="i">
                  <div v-if="scope.row.containerState === item.value">
                    {{ item.label }}
                  </div>
                </div>
              </div>
              <!-- 发票 -->
              <div v-else-if="item.key === 'invoice'">
                <!-- <el-upload action="/" :http-request="(file) =>
                  uploadVideo(
                    scope.row.containerBatchNo,
                    scope.row.containerState,
                    file
                  )
                  " accept=".pdf" :limit="1" :show-file-list="false">
                  <el-button class="list-btn btn-blue" ref="uploadVideo">{{ $t("common.upload") }}
                  </el-button>
                </el-upload> -->
                <my-upload size="mini" v-model="scope.row.pdfurl" :fileName.sync="scope.row.invoiceFilename" accept=".pdf" :limit="1" listType="text" isDelInfo
                  @input="myUploadPdfurl(scope.row, $event)" modular="FBAContainer" class="upload-style-custom">
                  <el-button class="list-btn btn-blue">{{ $t("common.upload") }}
                  </el-button>
                </my-upload>
                <!-- <span  @click="downloadFile(scope.row)" style="cursor:pointer">{{scope.row.invoiceUrl}}</span> -->
                <!-- <a class="link" @click="downloadFile(scope.row)">{{
                  scope.row.invoiceUrl
                }}</a> -->
              </div>
              <div v-else-if="item.key === 'boxNum'">
                {{ scope.row.containerBoxesCount }}
              </div>
              <!-- 国际物流 -->
              <div v-else-if="item.key === 'logisticsInfo'">
                <div class="lx-text-center logistics-company-row">
                  <el-tooltip class="item" effect="dark" :content="routeLabel(scope.row.route)" placement="top">
                    <img class="freight-icon" :src="routeIcon(scope.row.route)" :alt="routeLabel(scope.row.route)" />
                  </el-tooltip>
                  <span>{{ scope.row.logisticeCompany }}</span>
                </div>
                <div class="lx-text-center">
                  <span v-if="scope.row.waybillNumber && (scope.row.waybillNumber.toLocaleLowerCase().includes('dq') || (scope.row.companySign && (scope.row.companySign.toLocaleLowerCase().includes('hy'))))">
                    <a target="_blank" :href="scope.row.statusQueryWebsit + '?no=' + scope.row.waybillNumber">{{scope.row.waybillNumber}}</a>
                  </span>
                  <span v-else-if="scope.row.sagawa === '1'">
                    <a target="_blank" :href="'https://e-customer.sagawa-exp.co.jp/k2k?okurijoNo=' + scope.row.waybillNumber">{{ scope.row.waybillNumber }}</a>
                  </span>
                  <!--                  <span v-else-if="scope.row.sagawa === '2'">-->
                  <!--                      <a target="_blank" :href="'https://e-customer.sagawa-exp.co.jp/k2k?okurijoNo=' + scope.row.waybillNumber">{{scope.row.waybillNumber}}</a>-->
                  <!--                  </span>-->
                  <span v-else>
                    {{ scope.row.waybillNumber }}
                  </span>
                </div>
                <div class="lx-text-center">
                  <div v-html="scope.row.logisticeState"></div>
                  <!-- <span v-for="(item, i) in containerStateList" :key="i">
                        <span v-if="scope.row.containerState === item.value">
                          {{ item.label }}
                        </span>
                      </span> -->
                </div>
              </div>
              <!-- <div v-else-if="item.key === 'receiver'">
                {{ scope.row.recipientName }}
              </div>
              <div v-else-if="item.key === 'receiverCode'">
                {{ scope.row.zipCode }}
              </div> -->
              <!-- 收件信息 -->
              <div v-else-if="item.key === 'putIntent'">
                <div style="text-align: left" class="text-row-1">
                  <span>{{ $t("select.select16") }}:</span>
                  <span>{{ scope.row.recipientName }}</span>
                </div>
                <div style="text-align: left" class="text-row-1">
                  <span>{{ $t("OrderDetail.OrderDetail65") }}：</span>
                  <span>{{ scope.row.deliveryPhone }}</span>
                </div>
                <div style="text-align: left" class="text-row-1">
                  <span>{{ $t("addr.addr19") }}：</span>
                  <span>{{ scope.row.zipCode }}</span>
                </div>
                <div style="text-align: left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  <el-tooltip class="item" effect="dark" :content="scope.row.sendArea + scope.row.deliveryAddress" placement="top" popper-class="fba-tooltip-custom">
                    <span style="display:inline-block;width:100%;overflow:hidden;text-overflow:ellipsis;">
                      <span>{{ $t("address.address9") }}：</span>
                      <span>{{ scope.row.sendArea + scope.row.deliveryAddress }}</span>
                    </span>
                  </el-tooltip>
                </div>
              </div>
              <!-- 进口商信息 -->
              <div v-else-if="item.key === 'senderAddress'">
                <div style="text-align: left" class="text-row-1">
                  <span>{{ $t("OrderDetail.OrderDetail19") }}：</span>
                  <span>{{ scope.row.senderName }}</span>
                </div>
                <div style="text-align: left" class="text-row-1">
                  <span>{{ $t("OrderDetail.OrderDetail65") }}：</span>
                  <span>{{ scope.row.senderPhone }}</span>
                </div>
                <div style="text-align: left" class="text-row-1">
                  <span>{{ $t("addr.addr19") }}：</span>
                  <span>{{ scope.row.senderZipCode }}</span>
                </div>
                <div style="text-align: left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  <el-tooltip class="item" effect="dark" :content="scope.row.addresserArea + scope.row.senderAddress" placement="top" popper-class="fba-tooltip-custom">
                    <span style="display:inline-block;width:100%;overflow:hidden;text-overflow:ellipsis;">
                      <span>{{ $t("address.address9") }}：</span>
                      <span>{{ scope.row.addresserArea + scope.row.senderAddress }}</span>
                    </span>
                  </el-tooltip>
                </div>
              </div>
              <div v-else-if="item.key === 'route'">
                <img class="freight-icon" :src="routeIcon(scope.row.route)" :alt="routeLabel(scope.row.route)" :title="routeLabel(scope.row.route)" />
              </div>
              <div v-else-if="item.key === 'remark'">
                {{ scope.row.comments }}
              </div>
              <div v-else-if="item.key === 'attachment'">
                <!-- <el-upload v-if="scope.row.containerState == '6'" action="/"
                  :http-request="(file) => uploadAttachment(file, scope.row)" :before-upload="(file) => beforeUploadFiles(file, scope.row.attachment)
                    " :show-file-list="false">
                  <el-button class="list-btn btn-blue" ref="uploadAttachment">{{ $t("common.upload") }}
                  </el-button>
                </el-upload> -->
                <my-upload v-if="scope.row.containerState == '6'" size="mini" isJson isDelInfo v-model="scope.row.attachment" mode="array"
                  @input="myUpdateAttachment(scope.row, $event)" listType="text" :limit="5" :keyObject="{ url: 'url', name: 'name' }"
                  class="upload-style-custom">
                  <el-button class="list-btn btn-blue" ref="uploadAttachment">{{ $t("common.upload") }}
                  </el-button>
                </my-upload>
                <!-- <template v-for="(item, i) in getAttachment(scope.row.attachment)">
                  <el-tag v-if="item.type === 0 && item.customerDelete === 0" :key="i"
                    :closable="scope.row.containerState == '6'" size="medium" @click="viewAttachment(item)"
                    @close="deleteAttachment(item, scope.row)" style="
                      display: block;
                      height: auto;
                      text-align: left;
                      white-space: normal;
                      margin-top: 5px;
                      cursor: pointer;
                    ">
                    {{ item.name }}
                  </el-tag>
                </template> -->
              </div>

              <!--YFF/RSL/FBA/ZOZO-->
              <div v-else-if="item.key === 'containerOrderType'">
                <el-select v-model="scope.row.containerOrderType" placeholder="请选择" size="small" disabled>
                  <el-option v-for="(item, index) in fbaOptions" :key="index" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </div>

              <div v-else-if="item.key === 'createTime'">
                <div>{{ formatDateYMD(scope.row.createTime) }}</div>
                <div>{{ formatTimeHMS(scope.row.createTime) }}</div>
              </div>
              <div v-else-if="item.key === 'sendTime'" style="display: flex;flex-direction: column;align-items: center;">
                <div>{{ formatDateYMD(scope.row.sendTime) }}</div>
                <div>{{ formatTimeHMS(scope.row.sendTime) }}</div>
                <!-- <el-button style="width:auto;" v-if="scope.row.containerState==4" @click="handleStorage(scope.row)"
                  class="list-btn-four btn-blue">{{ $t('inStorageOrder.inStorageOrder14') }}</el-button> -->
              </div>
              <div v-else-if="item.key === 'userCode'">
                {{ scope.row.userName }}
              </div>
            </template>
          </el-table-column>
        </lx-table>
        <el-pagination class="lx-page-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 装箱单展示 -->
    <el-dialog :visible.sync="ContainerOrderListVisible" width="70%" @close="ContainerOrderDialogClosed" destroy-on-close>
      <!-- <el-button type="primary" style="margin-bottom:15px" @click="handleExport">
        {{$t('export')}}</el-button> -->
      <el-table :header-cell-style="tableStyle.headerStyle" :data="containerOrderList" border stripe style="width: 100%" v-loading="containerOrderListloading">
        <el-table-column fixed="left" type="index" align="center" :label="$t('wzbg.wz6')" width="40"></el-table-column>
        <el-table-column fixed="left" align="center" prop="clientManagerUserName" :label="$t('cnumber.cnumber30')" width="90"></el-table-column>
        <el-table-column fixed="left" prop="orderId" align="center" :label="$t('fba.orderNo')" width="70"></el-table-column>
        <!-- <el-table-column prop="fnsku" label="fnsku" align="center" width="90"></el-table-column> -->
        <el-table-column fixed="left" prop="goodsName" :label="$t('fba.goodsName')" min-width="200"></el-table-column>
        <el-table-column fixed="left" prop="pictureUrl" :label="$t('OrderDetail.OrderDetail54')" min-width="90">
          <template v-slot="scope">
            <img @click="imgclick(scope.row.pictureUrl)" :src="scope.row.pictureUrl" alt="" style="width: 70px; height: 70px" />
          </template>
        </el-table-column>
        <el-table-column prop="goodsNumber" :label="$t('orderList.orderList28')" align="center" min-width="100"></el-table-column>
        <el-table-column prop="colour" :label="$t('fba.color')" align="center" min-width="100"></el-table-column>
        <el-table-column prop="goodsSize" :label="$t('fba.size')" align="center" min-width="100"></el-table-column>
        <el-table-column prop="boxNum" :label="$t('fba.packNo')" align="center" min-width="100">
          <template v-slot="scope">
            <div v-for="(item,index) in scope.row.newBoxNum" :key="index">
              {{item}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orderType" label="FBA/YFF/RSL" align="center" min-width="90">
          <template v-slot="scope">
            <span v-if="scope.row.orderType == 0">FBA</span>
            <span v-if="scope.row.orderType == 1">{{
              $t("filter.filter36")
            }}</span>
            <span v-if="scope.row.orderType == 2">YFF</span>
<!--            <span v-if="scope.row.orderType == 3">ZOZO</span>-->
            <span v-if="scope.row.orderType == 4">RSL</span>
          </template>
        </el-table-column>
        <el-table-column prop="fnsku" :label="$t('createOrder.createOrder24')" align="center" min-width="100"></el-table-column>
        <el-table-column prop="asin" label="ASIN" width="90"></el-table-column>
        <el-table-column prop="goodsNameCus" :label="$t('OrderDetail.OrderDetail55')" align="center" width="150">
          <template v-slot="scope">
            <el-input type="textarea" placeholder="" v-model="scope.row.goodsNameCus" size="small" disabled>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" align="center" :label="$t('fba.orderState')" width="90">
          <template v-slot="scope">
            <div v-for="(item, i) in orderStatusOptions" :key="i">
              <div v-if="scope.row.orderStatus == item.value">
                {{ item.label }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="categoryFlag" :label="$t('fba.warehouseRetention')" align="center" min-width="140">
          <template v-slot="scope">
            <div>
              <span
                v-if="
                  scope.row.warehouseStorageDays != null &&
                  !['52', '72', '84'].includes(scope.row.orderStatus) &&
                  scope.row.checkFinishTime != null
                "
              >
                <span v-if="scope.row.warehouseStorageDays >= 10">
                  {{ $t("orderList.orderList140") }}{{ scope.row.warehouseStorageDays }}日
                </span>
                <span v-if="scope.row.warehouseStorageDays < 10 && scope.row.warehouseStorageDays > 0" style="color: orange">
                  {{ $t("orderList.orderList140") }}{{ scope.row.warehouseStorageDays }}日
                </span>
                <span v-if="scope.row.warehouseStorageDays == 0" style="color: red">
                  {{ $t("orderList.orderList140") }}{{ scope.row.warehouseStorageDays }}日
                </span>
              </span>
              <span
                v-else-if="
                  scope.row.chargingDays > 0 &&
                  !['52', '72', '84'].includes(scope.row.orderStatus) &&
                  scope.row.categoryPrice != 0 &&
                  scope.row.freeWarehousing == '0'
                "
                >{{ $t("orderList.orderList141") }}{{ scope.row.categoryPrice }}{{ $t("orderList.orderList142") }}{{ scope.row.chargingDays }}日)</span
              >
              <span v-else-if="scope.row.freeWarehousing !== null && ['2', '0', '4', '8', '24','28','32','36','68','40','82','26', '88'].includes(scope.row.orderStatus)">
                {{ scope.row.freeWarehousing === '0' ? $t("running.suspended0") : $t("running.suspended1") }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsCount" :label="$t('fba.goodsNumber')" align="center" width="120"></el-table-column>
        <!-- <el-table-column prop="waitingCount" :label="$t('fba.packingNumber')" align="center" width="90"></el-table-column> -->
        <!-- <el-table-column prop="badCount" :label="$t('fba.badToHandle')" align="center" width="100"></el-table-column>
        <el-table-column prop="exchangCount" :label="$t('fba.exchanging')" width="70"></el-table-column>
        <el-table-column prop="reissueCount" align="center" :label="$t('fba.reissuing')" width="70"></el-table-column> -->
        <el-table-column prop="refundCount" :label="$t('fba.returnNumber')" align="center" width="90"></el-table-column>
        <el-table-column prop="destroyCount" :label="$t('fba.destroyNumber')" align="center" width="90"></el-table-column>
        <el-table-column prop="netWeight" :label="$t('fba.netWeight')" align="center" width="90">
          <template v-slot="scope">
            <div>
              {{ scope.row.netWeight ? scope.row.netWeight.toFixed(3) : '-' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="canApplyCount" :label="$t('fba.canApplyCount')" align="center" width="90"></el-table-column>
        <el-table-column prop="containerGoodsCount" :label="$t('fba.applyNumber')" align="center" width="90"></el-table-column>
        <el-table-column prop="containerGoodsCountInstalled" :label="$t('fba.packNumber')" align="center" width="90"></el-table-column>
      </el-table>
      <!-- </div>  -->
      <span slot="footer" class="dialog-footer">
        <!--<el-button class="form-btn btn-blue" style="margin-right:15px" v-if="this.orderDetail?.containerState != 6 && this.orderDetail?.containerState != 5 && this.orderDetail?.containerState != 0"
          @click="handleExportBoxWrapDetail">{{ $t("fba.downLoad3") }}</el-button>-->
        <el-button v-if="customerBox.customerBoxStatus === '0'" key="0" class="form-btn btn-blue" style="margin-right:15px"
          @click="handleExportBoxDetail">{{ $t("export") }}</el-button>
        <el-button v-if="customerBox.customerBoxStatus === '1'" key="1" class="form-btn" type="danger" style="margin-right:15px" readonly
          loading>{{ $t("fba.downLoad1") }}</el-button>
        <el-button v-if="customerBox.customerBoxStatus === '2'" key="2" class="form-btn" type="success" style="margin-right:15px"
          @click="handleExportEndBoxDetail(customerBox.customerBoxUrl)" icon="el-icon-download">{{ $t("fba.downLoad2") }}</el-button>
        <el-button class="form-btn btn-gray" @click="ContainerOrderListVisible = false">{{ $t("common.close") }}</el-button>
      </span>
    </el-dialog>
    <!-- 提醒 -->
    <el-dialog :title="$t('orderList.orderList23')" :visible.sync="replyDialogVisible" width="50%" @close="replyDialogClose">
      <el-form :model="replyInfo" :rules="rules" ref="replyInfo" label-width="140px" class="demo-replyInfo">
        <!-- 只读 -->
        <el-form-item :label="$t('orderList.orderList50')">
          <span>{{ $t("mess.mess58") }}</span>
        </el-form-item>
        <el-form-item :label="$t('fba.batchNo') + '：'">
          <span>{{ replyMessageInfo.containerBatchNo }}</span>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item :label="$t('orderList.orderList53')" prop="remindingTitle">
          <el-input maxlength="100" v-model="replyInfo.remindingTitle"></el-input>
        </el-form-item>
        <el-form-item :label="$t('orderList.orderList54')" prop="remindingContent">
          <!-- <el-input v-model="replyInfo.remindingContent"></el-input> -->
          <quill-editor ref="text" v-model="replyInfo.remindingContent" :options="editorOption" />
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('orderList.orderList55')">
          <el-upload class="editor-slide-upload" action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com" :data="imgDataObj" :multiple="true" :file-list="listObj"
            :show-file-list="true" list-type="picture-card" accept="image/png,image/jpeg" :on-remove="handleImgRemove" :on-success="handleImgSuccess"
            :on-exceed="handleExceed" :before-upload="beforeImgUpload" :on-preview="handlePictureCardPreview" :limit="9">
            <el-button size="small" type="primary" class="btn">{{
              $t("upload.button")
            }} </el-button>
            <div ref="preview" @paste="handlePaste" class="paste-img"></div>
            <el-dialog :append-to-body="true" :visible.sync="viewVisible">
              <img width="100%" :src="viewImageUrl" alt="" />
            </el-dialog>
          </el-upload>
        </el-form-item>
        <!-- 上传附件 -->
        <el-form-item :label="$t('createOrder.createOrder117')">
          <el-upload class="editor-slide-upload" action="" :on-remove="handleRemove" :before-upload="beforeUploadFile" :multiple="true" :show-file-list="true"
            :limit="3" :on-exceed="handleExceed" :file-list="attachmentList" :http-request="excelUploadRequest">
            <el-button class="search-btn btn-blue">{{
              $t("createOrder.createOrder117")
            }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="replyDialogClose">{{
          $t("cancel")
        }}</el-button>
        <el-button class="form-btn btn-blue" @click="replySave('replyInfo')">{{
          $t("submit")
        }}</el-button>
      </div>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image" />
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <!-- 仓储费明细 -->
    <el-dialog :title="$t('inStorageOrder.inStorageOrder14')" :visible.sync="storageSync" width="70%">
      <p style="margin:-30px 0 20px 0;display: flex;justify-content: flex-end;">{{$t('inStorageOrder.inStorageOrder15')}}：{{ totalCategoryPrice }}</p>
      <el-table :data="storageList" style="width: 100%" border :header-cell-style="tableStyle.headerStyle">
        <el-table-column type="index" :label="$t('createOrder.createOrder120')" width="80" align="center">
        </el-table-column>
        <el-table-column prop="boxNo" :label="$t('fba.packNo')" width="120" align="center">
        </el-table-column>
        <el-table-column prop="orderId" :label="$t('createOrder.createOrder104')" width="120" align="center">
        </el-table-column>
        <el-table-column prop="goodsName" :label="$t('goods.goods2')" width="150">
        </el-table-column>
        <el-table-column prop="boxGoodsCount" :label="$t('inStorageOrder.inStorageOrder17')" align="center">
        </el-table-column>
        <el-table-column prop="showAbnormalOrder" :label="$t('inStorageOrder.inStorageOrder16'||'异常单号/原因/方案')" width="100" align="center">
          <template #default="{row}">{{ row.showAbnormalOrder=='否'?'否':row.showAbnormalOrder }}</template>
        </el-table-column>
        <el-table-column prop="freeWarehousing" :label="$t('inStorageOrder.inStorageOrder8')" width="100" align="center">
          <template #default="{row}">{{ row.freeWarehousing==0?$t('running.suspended0'):$t('running.suspended1') }}</template>
        </el-table-column>
        <el-table-column prop="inLibraryTime" :label="$t('inStorageOrder.inStorageOrder9')" width="100" align="center">
          <template #default="{row}">
            <div style="white-space: pre-wrap; /* 保留空格和换行符 */">{{ formatTimeBreak(row.inLibraryTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="startChargingTime" :label="$t('inStorageOrder.inStorageOrder10')" width="100" align="center">
          <template #default="{row}">
            <div style="white-space: pre-wrap; /* 保留空格和换行符 */">{{ formatTimeBreak(row.startChargingTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sendTime" :label="$t('inStorageOrder.inStorageOrder11')" width="100" align="center">
          <template #default="{row}">
            <div style="white-space: pre-wrap; /* 保留空格和换行符 */">{{ formatTimeBreak(row.sendTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="dayDifference" :label="$t('inStorageOrder.inStorageOrder12')" width="100" align="center">
        </el-table-column>
        <el-table-column prop="categoryPrice" :label="$t('inStorageOrder.inStorageOrder13')" width="100" align="center">
          <template #default="{row}">{{ typeof row.categoryPrice === "number" ? row.categoryPrice.toFixed(2) : 0 }}</template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn  btn-blue" key="0" style="margin-right:15px" @click="storageExport">{{ $t('export') }}</el-button>
        <el-button class="form-btn btn-blue" @click="storageSync = false">{{ $t('recharge.rechargeConfirmButtonText') }}</el-button>
      </div>
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>
  </div>
</template>

<script>
import ChildCode from "@/components/ChildCode/index.vue";
import { getRouteQueryCache, setRouteQueryCache } from "@/assets/js/routeQueryCache"

const toolbarOptions = [
  ["bold"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
]
import { columns as originColumns } from "./columns"
import { filterList } from "@/assets/js/utils"
import LxTable from "@/components/LxTable"
import LxSort from "@/components/LxSort/index"
import tableCon from "../../views/tableContainer"
import Oss from "@/assets/js/oss"
const seaFreightIcon = require("@/assets/img/sea_freight.svg")
const airFreightIcon = require("@/assets/img/air_freight.svg")
export default {
  components: {
    ChildCode,
    LxTable,
    LxSort,
    tableCon,
  },
  data () {
    return {
      isClientManage: this.$store.state.isClientManage,
      isActive: true,
      imgurl: "",
      curIndex: 0, // 默认选中第0个
      isLoading: true,
      visible: false,
      storageSync: false,
      isVisibleSort: false,
      storageList: [],
      totalCategoryPrice: undefined,
      currentdate: "",
      seaFreightIcon,
      airFreightIcon,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      menuSettingData: {
        menuId: "FBA",
      },
      queryInfo: {
        containerBatchNo: "",
        logisticeCompany: "",
        customerId: "",
        realName: "",
        containerState: "",
        sendArea: "",
        createTimeStart: "",
        createTimeEnd: "",
        waybillNumber: "",
        route: "",
        pageSize: 10,
        pageNum: 1,
      },
      containerBatchNo: "",
      orderData: {
        waitPayNum: 0,
      },
      containerStateList: [
        //装箱状态
        {
          value: "0",
          label: this.$t("fba.packing"),
        },
        {
          value: "1",
          label: this.$t("fba.toPay"),
        },
        {
          value: "2",
          label: this.$t("fba.toUploadInvoice"),
        },
        {
          value: "3",
          label: this.$t("fba.toSend"),
        },
        {
          value: "4",
          label: this.$t("fba.sent"),
        },
        {
          value: "5",
          label: this.$t("fba.cancelled"),
        },
        {
          value: "6",
          label: this.$t("fba.toPack"),
        },
        {
          value: "7",
          label: this.$t("fba.finishBox"),
        },
        {
          value: "11",
          label: this.$t("goods.goods3"),
        },
      ],
      routeList: [
        {
          value: "1",
          label: this.$t("FBAContainerOrder.FBAContainerOrder1"),
        },
        {
          value: "2",
          label: this.$t("FBAContainerOrder.FBAContainerOrder2"),
        },
      ],
      //订单状态
      orderStatusOptions: [],
      ContainerOrderListVisible: false,
      containerOrderList: [],
      //物流公司的下拉地址
      dropDownList: [],
      // containerDateRangeValue: [],
      containerList: [],
      total: 0,
      replyMessageInfo: {},
      replyDialogVisible: false,
      attachmentList: [],
      listObj: [],
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      replyInfo: {
        remindingContent: "",
        remindingTitle: "",
        replyPicture: "",
        attachment: "",
      },
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
          },
        },
      },
      viewImageUrl: "",
      viewVisible: false,
      rules: {
        remindingTitle: [
          {
            required: true,
            message: this.$t("orderList.orderList62"),
            trigger: "blur",
          },
        ],
        remindingContent: [
          {
            required: true,
            message: this.$t("orderList.orderList63"),
            trigger: "blur",
          },
        ],
      },
      fbaOptions: [
        {
          name: this.$t("running.suspended0"),
          value: "1",
        },
        {
          name: "FBA",
          value: "0",
        },
        {
          name: "YFF",
          value: "2",
        },
        /*{
          name: "ZOZO",
          value: "3",
        },*/
        {
          name: "RSL",
          value: "4",
        },
      ],
      // 装箱单的导出控制
      customerBox: {
        customerBoxStatus: "",
        customerBoxUrl: "",
        pollingTimer: undefined
      },
      containerOrderListloading: false,
      orderDetail: null, // 当前点击的 订单的列表详情
    }
  },
  methods: {
    restoreQueryState () {
      const cache = getRouteQueryCache('FBA')
      if (!cache) return

      if (cache.queryInfo) {
        this.queryInfo = { ...this.queryInfo, ...cache.queryInfo }
      }
      if (typeof cache.curIndex === 'number') {
        this.curIndex = cache.curIndex
      }
    },
    saveQueryState () {
      setRouteQueryCache('FBA', {
        queryInfo: this.queryInfo,
        curIndex: this.curIndex,
      })
    },
    routeLabel (route) {
      return route === "1"
        ? this.$t("FBAContainerOrder.FBAContainerOrder1")
        : this.$t("FBAContainerOrder.FBAContainerOrder2")
    },
    routeIcon (route) {
      return route === "1" ? this.airFreightIcon : this.seaFreightIcon
    },
    // 打开仓储费明细
    handleStorage (row) {
      this.storageSync = true
      this.containerBatchNo = row.containerBatchNo
      this.getStorage(row)
      console.log(row, 'row')
    },
    async getStorage (row) {
      const { data: res } = await this.$http.get('/box/getStorageDetail', { params: { containerBatchNo: row.containerBatchNo } })
      console.log(res, 'res')
      if (res.code == 200) {
        this.storageList = res.data.extWarehouseDetailList
        this.totalCategoryPrice = res.data.totalCategoryPrice.toFixed(2)
      }
    },
    // 仓储费明细导出
    storageExport () {
      this.$http({
        url: "/box/exportStorageDetail",
        method: "get",
        responseType: "blob", // 表明返回服务器返回的数据类型
        params: { containerBatchNo: this.containerBatchNo },
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          //接口参数
        },
      })
        .then((res) => {
          //创建一个隐藏的a连接，
          const link = document.createElement("a")
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
          link.style.display = "none"
          //设置连接
          link.href = URL.createObjectURL(blob)
          link.download = `${this.$t('inStorageOrder.inStorageOrder14')}${this.containerBatchNo}.xlsm`
          document.body.appendChild(link)
          //模拟点击事件
          link.click()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleExportBoxDetail () {
      this.$http.post("box/cmExportBoxDetail", {
        containerBatchNo: this.ContainerInfo
      }).then((res) => {
        if (res.data.code === 200) {
          // this.$message({
          //   type: "success",
          //   message: res.data.message,
          // });
          // 启动轮询
          this.customerBox.customerBoxStatus = '1'
          this.pollingDownload()
        } else {
          this.$message({
            type: "error",
            message: "error",
          })
        }
      }).catch(() => {
      })
    },
    replySave (formName) {
      //提醒弹窗保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addReply()
          this.replyDialogVisible = false
          this.btnReplyFlag == 0
        } else {
          this.$message.error(this.$t("orderList.orderList104"))
          return false
        }
      })
    },
    messageAdd (row) {
      //提醒
      const { MessageSend } = this
      // MessageSend.replyInfo.messageType = "5";
      // MessageSend.httpUrl = "cmUser/message/sendMessage";
      // MessageSend.message.onAdd("提醒", [
      //   {
      //     key: "orderId",
      //     type: "elInput", //view
      //     label: "批次号：",
      //     vModel: row.containerBatchNo,
      //     vBind: { disabled: true },
      //   },
      // ]);
      MessageSend.message.onAdd("", row)
    },
    remind (row) {

      //提醒
      this.handleImgSubmit()
      this.replyDialogVisible = true
      this.attachmentList = []
      this.listObj = []
      this.replyMessageInfo = row
      this.replyInfo = {
        orderId: row.containerBatchNo,
        messageType: 5,
      }
    },
    handleImgSubmit () {
      var _this = this
      let arr = []
      Object.keys(_this.listObj).map((v) => {
        arr.push(_this.listObj[v].url)
      })
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message(this.$t("orderList.orderList105"))
        return false
      } else {
        if (arr.length > 9) {
          _this.$message.error(this.$t("orderList.orderList138"))
          return false
        }
        _this.replyInfo.replyPicture = arr.toString()
        _this.$emit("successCBK", arr)
        _this.listObj = []
        _this.imgDialogVisible = false
      }
      if (_this.attachmentList.length > 0) {
        _this.replyInfo.attachment = JSON.stringify(this.attachmentList)
      } else {
        _this.replyInfo.attachment = ""
      }
      return true
    },
    handleImgRemove (file, fileList) {
      // 显示使用
      Oss.imgRemove(file, this.listObj)
    },
    handleRemove (file, fileList) {
      for (let i = 0; i < this.attachmentList.length; i++) {
        let attach = this.attachmentList[i]
        if (file.name == attach.name) {
          this.attachmentList.splice(i, 1)
        }
      }
    },
    beforeImgUpload (file) {
      const _self = this
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        _self.$message.error(this.$t("createOrder.createOrder74"))
        return false
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/
      if (specialReg.test(file.name)) {
        _self.$message.error(this.$t("createOrder.specialChar"))
        return false
      }
      const fileName = file.uid
      this.listObj[fileName] = {}
      return new Promise((resolve, reject) => {
        _self.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = "" //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10)
            }
            num = new Date().getTime() + num //时间戳，用来生成编号。
            _self.imgDataObj.policy = response.data.data.policy
            _self.imgDataObj.signature = response.data.data.signature
            _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId
            _self.imgDataObj.key =
              response.data.data.dir + "/order/" + num + "${filename}"
            _self.imgDataObj.dir = response.data.data.dir + "/order"
            _self.imgDataObj.host = response.data.data.host
            _self.imgDataObj.timeStamp = num
            file.timeStamp = num
            Oss.imgCompress(file, this.listObj, resolve, reject)
          })
          .catch((err) => {
            reject(false)
          })
      })
    },
    handleImgSuccess (response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj)
    },
    handlePictureCardPreview (file) {
      this.viewImageUrl = file.url
      this.viewVisible = true
    },
    async handlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地")
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片")
        return
      }
      let formdata = new FormData()
      formdata.append("file", file)
      // 数据保存
      const { data: res } = await this.$http.post(
        "cmUser/message/uploadFile",
        formdata
      )
      if (res.code === 200) {
        this.listObj.push({
          name: res.data.fileName,
          url: res.data.filePath,
          hasSuccess: true,
          uid: Date.now(),
        })
      }
    },
    replyDialogClose () {
      //关闭提醒弹窗
      this.replyDialogVisible = false
    },
    async addReply () {
      if (!this.handleImgSubmit()) {
        return false
      }
      const { data: res } = await this.$http.post(
        "cmUser/message/sendMessage",
        this.replyInfo
      )
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        })
      } else {
        this.$message({
          type: "warning",
          message: res.message,
        })
      }
    },
    showImgDialog (index) {
      this.imgDialogVisible = true
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `${this.$t("createOrder.createOrder118")},${this.$t(
          "createOrder.createOrder92"
        )} ${files.length} ${this.$t("createOrder.createOrder93")},${this.$t(
          "createOrder.createOrder94"
        )} ${files.length + fileList.length} ${this.$t(
          "createOrder.createOrder93"
        )}`
      )
    },
    beforeUploadFile (file) {
      const extension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase()
      // const size = file.size / 1024 / 1024
      if (
        extension !== ".xls" &&
        extension !== ".xlsx" &&
        extension !== ".pdf"
      ) {
        this.$message.warning("只能上传excel和pdf文件")
        return false
      }
      // if (size > 10) {
      //   this.$message.warning('文件大小不得超过10M')
      // }
    },
    beforeUploadFiles (file, attachment) {
      let attachmentList = this.getAttachment(attachment)
      let fileList = attachmentList.filter((item) => {
        return item.type === 0 && item.customerDelete === 0
      })

      // const extension = file.name.substring(file.name.lastIndexOf('.'))
      // if (extension !== '.xls' && extension !== '.xlsx' && extension !== '.pdf' && extension !== '.mp4') {
      //   this.$message.warning(this.$t('orderList.orderList137'))
      //   return false
      // }

      if (fileList.length + 1 > 5) {
        this.$message.error(this.$t("orderList.orderList143"))
        return false
      }
      return true
    },
    // 批量导入
    async excelUploadRequest (file) {
      let formdata = new FormData()
      formdata.append("file", file.file)
      const { data: res } = await this.$http.post(
        "cmUser/message/uploadFile",
        formdata
      )
      if (res.code === 200) {
        let { fileName, filePath } = res.data
        this.attachmentList.push({ name: file.file.name, url: filePath })
      }
    },
    async uploadAttachment (file, row) {
      let formdata = new FormData()
      formdata.append("file", file.file)
      const { data: res } = await this.$http.post(
        "cmUser/message/uploadFile",
        formdata
      )
      if (res.code === 200) {
        let { fileName, filePath } = res.data
        let attachmentList = this.getAttachment(row.attachment)
        attachmentList.push({
          name: file.file.name,
          url: filePath,
          type: 0,
          customerDelete: 0,
          operatorDelete: 0,
        })
        let attachment = ""
        if (attachmentList.length > 0) {
          attachment = JSON.stringify(attachmentList)
        }
        row.attachment = attachment
        this.$set(row, "attachment", attachment)
        const { data: updateAttachmentRes } = await this.$http.post(
          "container/updateAttachment",
          { id: row.id, attachment: attachment }
        )
        if (updateAttachmentRes.code !== 200) {
          this.$message.error(updateAttachmentRes.message)
        } else {
          this.$message({
            type: "success",
            message: this.$t("common.submitSuccess"),
          })
          await this.getContainerList()
        }
      }
    },
    myUpdateAttachment (row, event) {
      this.$http.post("container/updateAttachment", { id: row.id, attachment: event }).then(res => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: this.$t("common.submitSuccess"),
          })
        }
      })
    },
    viewAttachment (item) {
      window.open(item.url, "_blank")
    },
    deleteAttachment (item, row) {
      this.$confirm(this.$t("createOrder.createOrder68"), {
        confirmButtonText: this.$t("submit"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      }).then(async () => {
        let attachmentList = this.getAttachment(row.attachment)
        for (let i = 0; i < attachmentList.length; i++) {
          let attach = attachmentList[i]
          if (item.url == attach.url) {
            attachmentList.splice(i, 1)
          }
        }
        let attachment = ""
        if (attachmentList.length > 0) {
          attachment = JSON.stringify(attachmentList)
        }
        const { data: res } = await this.$http.post(
          "container/updateAttachment",
          { id: row.id, attachment: attachment }
        )
        if (res.code !== 200) {
          this.$message.error(res.message)
        } else {
          this.$message({
            type: "success",
            message: this.$t("common.submitSuccess"),
          })

          row.attachment = attachment
          this.$set(row, "attachment", attachment)

          // await this.getContainerList();
        }
      })
    },
    getAttachment (str) {
      if (str != null && str.length > 0) {
        return JSON.parse(str)
      }
      return []
    },
    imgclick (url, visible) {
      this.visible = true
      this.imgurl = url
    },
    // 获取已选择列
    getAsyncColumns () {
      return new Promise((resolve) => {
        this.$http
          .get("menu/menuSetting", {
            params: {
              menuId: "FBA",
            },
          })
          .then((res) => {
            var result = []
            if (res.data.code === 200) {
              var record = res.data.data
              this.menuSettingData = record
              result = JSON.parse(record.menuSetting)
            }
            if (result && result.length > 0) {
              // 过滤掉 containerOrderType
              result = result.filter(item => item.key !== 'containerOrderType' && item.key !== 'route')
              result.forEach((item) => {
                this.$set(item, "isShow", true)
              })
              let noSelectList = filterList(
                this.originColumns,
                result,
                "columnId"
              )
              this.columns = result.concat(noSelectList)
              this.asyncColumns = result
              resolve()
            } else {
              this.columns = this.originColumns
              this.columns.forEach((item) => {
                this.$set(item, "isShow", true)
              })
              this.asyncColumns = this.columns
              resolve()
            }
          })
      })
    },
    // 保存选择的列
    doSaveColumns (list) {
      var my = this
      var url = "menu/updateMenuSetting"
      // 过滤掉 containerOrderType
      list = list.filter(item => item.key !== 'containerOrderType')
      this.menuSettingData.menuSetting = JSON.stringify(list)
      this.$http.post(url, this.menuSettingData).then((res) => {
        if (res.data.code === 200) {
          this.isVisibleSort = false
          my.$message({
            type: "success",
            message: this.$t("common.saveSuccess"),
          })
          this.queryInfo.pageNum = 1
          this.getAsyncColumns().then(() => {
            this.getContainerList()
          })
        } else {
          my.$message({
            type: "warning",
            message: this.$t("common.saveFailed"),
          })
        }
      })
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    containerDateRange () { },
    queryInfoClear () {
      this.queryInfo = {
        containerBatchNo: "",
        customerId: "",
        realName: "",
        containerState: "",
        logisticeCompany: "",
        sendArea: "",
        createTimeStart: "",
        createTimeEnd: "",
        waybillNumber: "",
        route: "",
        pageSize: 10,
        pageNum: 1,
      }
      // this.containerDateRangeValue = [];
      this.curIndex = 0
      this.shipDateRangeValue = []
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.getContainerList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage
      this.getContainerList()
    },
    searchList () {
      this.queryInfo.pageNum = 1
      this.getContainerList()
      this.getStatisticalNum()
    },
    quickSearchList (val, index) {
      this.curIndex = index
      this.queryInfo.pageNum = 1
      this.queryInfo.containerState = val
      this.getContainerList()
      this.getStatisticalNum()
    },
    normalizeTs (ts) {
      let v = ts
      if (typeof v === 'string') v = Number(v)
      if (!v) return null
      return v < 1000000000000 ? v * 1000 : v
    },
    pad2 (n) {
      return n < 10 ? '0' + n : '' + n
    },
    formatDateYMD (ts) {
      const ms = this.normalizeTs(ts)
      if (!ms) return '--'
      const d = new Date(ms)
      return d.getFullYear() + '-' + this.pad2(d.getMonth() + 1) + '-' + this.pad2(d.getDate())
    },
    formatTimeHMS (ts) {
      const ms = this.normalizeTs(ts)
      if (!ms) return '--'
      const d = new Date(ms)
      return this.pad2(d.getHours()) + ':' + this.pad2(d.getMinutes()) + ':' + this.pad2(d.getSeconds())
    },
    dateFormat (time) {
      let date = new Date(time)
      let year = date.getFullYear()
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
      let hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
      // 拼接
      return year + "" + month + "" + day + "" + hours + "" + minutes
    },
    handleExport () {
      let date = this.dateFormat(new Date())
      this.$http({
        url: "order/exportWaitPayOrder?containerBatchNo=" + this.ContainerInfo,
        method: "get",
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          //创建一个隐藏的a连接，
          const link = document.createElement("a")
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
          link.style.display = "none"
          //设置连接
          link.href = URL.createObjectURL(blob)
          link.download = `装箱申请P${date}.xlsx`
          document.body.appendChild(link)
          //模拟点击事件
          link.click()
        })
        .catch(() => { })
    },
    //上传pdf
    uploadVideo (containerBatchNo, containerState, file) {
      const isPDF = file.file.type === "application/pdf"
      if (!isPDF) {
        this.$message.error(this.$t("common.uploadOnlyPdf"))
        return
      }
      let formdata = new FormData()
      formdata.append("file", file.file)
      formdata.append("modular", "FBAContainer")
      formdata.append("type", "PDF")
      this.$http.post("aliyun/oss/upload", formdata).then((res) => {
        if (res.data.code == 200) {
          const { data: res1 } = this.$http.post("container/uploadInvoice", {
            containerBatchNo: containerBatchNo,
            containerState: containerState,
            invoiceUrl: res.data.data,
          })
          this.$message.success(this.$t("common.uploadSuccess"))
          this.getContainerList()
          this.getStatisticalNum()
        }
      })
    },
    myUploadPdfurl (row, event) {
      this.$http.post("container/uploadInvoice", {
        containerBatchNo: row.containerBatchNo,
        containerState: row.containerState,
        invoiceUrl: event,
        invoiceFilename: row.invoiceFilename,
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t("common.uploadSuccess"))
          this.getContainerList()
          this.getStatisticalNum()
        }
      })
    },

    //下载文件
    async downloadFile (row) {
      let formdata = new FormData()
      formdata.append("fileUrl", row.pdfurl)
      formdata.append("fileName", row.invoiceUrl)
      var url = "api/aliyun/oss/download" // 请求的url + id
      var xhr = new XMLHttpRequest()
      xhr.open("POST", url, true)
      xhr.responseType = "blob"
      xhr.setRequestHeader("client_type", "DESKTOP_WEB")
      xhr.setRequestHeader(
        "Authorization",
        window.sessionStorage.getItem("token")
      ) // 自定义请求头
      xhr.onload = function () {
        if (this.status == 200) {
          var blob = this.response
          var fileName = row.invoiceUrl
          if (window.navigator.msSaveOrOpenBlob) {
            // IE浏览器下
            navigator.msSaveBlob(blob, fileName)
          } else {
            var link = document.createElement("a")
            link.href = window.URL.createObjectURL(blob)
            link.download = fileName
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
        }
      }
      xhr.send(formdata)
    },
    //检索全部的批次号
    async getContainerList () {
      const { data: res } = await this.$http.post(
        "container/getAllContainerList",
        this.queryInfo
      )
      this.containerList = res.data.list
      this.total = res.data.total
    },
    async getStatisticalNum () {
      //获取
      const { data: res } = await this.$http.get(
        "/container/getStatisticalNum",
        { params: this.queryInfo }
      )
      this.orderData = res.data
    },
    //获取全部的物流公司
    async getDropDownList () {
      const { data: res } = await this.$http.post(
        "cms/logisticsCompany/getDropDownList"
      )
      this.dropDownList = res.data
    },
    // downloadUrl (url) {
    //   window.open(url, '_blank')
    // },
    cannelBill (row) {
      this.$confirm(this.$t("fba.confirmCancelPackList"), {
        confirmButtonText: this.$t("common.confirm"),
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: this.$t("common.cancel"),
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$http.post(
            `cmsContainer/modifyContainerOrder`,
            {
              id: row.id,
              containerState: 5,
              containerBatchNo: row.containerBatchNo,
            }
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: this.$t("common.cancelSuccess"),
            })
            await this.getContainerList()
            this.getStatisticalNum()
          }
        })
        .catch((e) => {
          // console.log(e)
        })
    },
    ContainerOrderDialogClosed () {
      this.ContainerOrderListVisible = false
      // 关闭的时候清空装箱单的轮询或者状态内容
      this.clearPolling()
      this.customerBox.customerBoxStatus = "";
      this.customerBox.customerBoxUrl = "";
      this.containerOrderList = [];
      this.containerOrderListloading = false;
      this.orderDetail = null;
    },
    ContainerOrderList (row) {
      this.ContainerOrderListVisible = true;
      this.ContainerInfo = row.containerBatchNo;
      this.getContainerOrderList();
      this.orderDetail = row;
    },
    //本批次下的装箱单
    async getContainerOrderList () {
      // 获取装箱单的按钮状态
      this.$http.get('container/getBatchBillStatus', {
        params: {
          containerBatchNo: this.ContainerInfo
        }, headers: {
          noLoading: true
        }
      }).then(({ data: res }) => {
        if (res.code === 200) {
          if (res.data.customerBoxStatus === '1') {
            this.customerBox.customerBoxStatus = res.data.customerBoxStatus
            this.pollingDownload()
          } else {
            this.customerBox.customerBoxStatus = res.data.customerBoxStatus
            this.customerBox.customerBoxUrl = res.data.customerBoxUrl
          }
        } else {
          this.$message.error(res.message)
        }
      }).catch((error) => {
        console.error(error)
      })
      this.containerOrderListloading = true;
      const { data: res } = await this.$http.post(
        "container/getContainerOrderList",
        {
          containerBatchNo: this.ContainerInfo,
        }
      )
      this.containerOrderList = res.data.map(v=>{
        return{
          ...v,
          newBoxNum: v.boxNum?.split(",") || []
        }
      }) || [];
      this.containerOrderListloading = false;
    },
    //新建装箱单
    newBuiltOrder () {
      this.$router.push({
        name: "FBAContainerOrder",
      })
    },
    //支付
    toOrderBillPay (row) {
      this.$router.push({
        name: "FBABill",
        query: {
          containerBatchNo: row.containerBatchNo,
          isEdit: 1,
          containerState: row.containerState,
        },
      })
    }, //账单
    toOrderBill (row) {
      this.$router.push({
        name: "FBABill",
        query: {
          containerBatchNo: row.containerBatchNo,
          isEdit: 0,
          containerState: row.containerState,
        },
      })
    },
    formatTimeBreak(val) {
      if (!val) return ''
      let str = ''
      if (typeof val === 'number') {
        str = this.$options.filters.dateFormatToSecond(val / 1000)
      } else {
        str = val
      }
      return str ? str.replace(' ', '\n') : ''
    },
    dateFormatYMDHMS (row, column, cellValue, index) {
      //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return ""
      let date = new Date(parseInt(cellValue) * 1000) //时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + "-"
      let M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1) + "-"
          : date.getMonth() + 1 + "-"
      let D =
        date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " "
      let h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":"
      let m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":"
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    toContainerDetail (row) {
      this.$router.push({
        name: "boxList",
        query: {
          containerBatchNo: row.containerBatchNo,
        },
      })
    },
    // 排序
    toSort () {
      this.isVisibleSort = true
    },
    // 初始化 table 宽度
    tableCellWidth (id) {
      const item = this.originColumns.find(it => it.key === id)
      if (item) {
        return item
      }
    },
    // 轮询炒作查询下载状态
    pollingDownload () {
      if (this.customerBox.customerBoxStatus === "1" && this.ContainerInfo) {
        this.pollingTimer = setTimeout(() => {
          this.$http.get('container/getBatchBillStatus', {
            params: {
              containerBatchNo: this.ContainerInfo
            }, headers: {
              noLoading: true
            }
          }).then(({ data: res }) => {
            if (res.code === 200) {
              if (res.data.customerBoxStatus === "1") {
                clearTimeout(this.customerBox.pollingTimer)
                this.pollingDownload()
              } else {
                this.clearPolling()
                this.customerBox.customerBoxStatus = res.data.customerBoxStatus
                this.customerBox.customerBoxUrl = res.data.customerBoxUrl
              }
            } else {
              this.$message.error(res.message)
              this.clearPolling()
            }
          }).catch((error) => {
            this.clearPolling()
            console.error(error)
          })
        }, 5000)
      }
    },
    // 清空轮询
    clearPolling () {
      if (this.customerBox.pollingTimer) {
        clearTimeout(this.customerBox.pollingTimer)
        this.customerBox.pollingTimer = undefined
      }
    },
    // 打开下载
    handleExportEndBoxDetail (url) {
      if (!url) {
        this.$message.error("error")
        return
      }
      window.open(url, "_blank")
    },
    handleExportBoxWrapDetail() {
      this.$http({
        url: "box/exportBoxDetail",
        method: "GET",
        params: {
          containerBatchNo: this.ContainerInfo
        },
        responseType: "blob", //关键点
      }).then(res => {
        //下载文件操作
        const link = document.createElement("a");
        let blob = new Blob([res.data]); //生成blob对象
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${this.$t('fba.downLoad3')}.xlsx`); //下载的文件名以及文件格式
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(err => {
        console.error(err);
      })
    }
  },
  watch: {
    //监听时间选择器绑定值变化
    // containerDateRangeValue() {
    //   //解决时间选择器清空后 绑定值为null问题
    //   if (!this.containerDateRangeValue) {
    //     this.containerDateRangeValue = [];
    //     this.queryInfo.createTimeStart = "";
    //     this.queryInfo.createTimeEnd = "";
    //   } else {
    //     if (this.containerDateRangeValue.length > 0) {
    //       this.queryInfo.createTimeStart =
    //           this.containerDateRangeValue[0] / 1000;
    //       this.queryInfo.createTimeEnd = this.containerDateRangeValue[1] / 1000;
    //     }
    //   }
    // },
    shipDateRangeValue () {
      if (!this.shipDateRangeValue) {
        this.shipDateRangeValue = []
        this.queryInfo.sendTimeStart = ""
        this.queryInfo.sendTimeEnd = ""
      } else {
        if (this.shipDateRangeValue.length > 0) {
          this.queryInfo.sendTimeStart = this.shipDateRangeValue[0] / 1000
          this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1] / 1000
        }
      }
    },
  },
  created () {
    this.restoreQueryState()
    if (this.$route.query.containerBatchNo !== undefined) {
      this.queryInfo.containerBatchNo = this.$route.query.containerBatchNo
    }
    this.orderStatusOptions = [
      {
        value: "0",
        label: this.$t("fba.toWarehouse"),
      },
      {
        value: "1",
        label: this.$t("fba.fba7"),
      },
      {
        value: "2",
        label: this.$t("fba.fba8"),
      },
      {
        value: "4",
        label: this.$t("fba.warehoused"),
      },
      {
        value: "8",
        label: this.$t("fba.sampling"),
      },
      {
        value: "12",
        label: this.$t("fba.sampled"),
      },
      {
        value: "16",
        label: this.$t("fba.inStorage"),
      },
      {
        value: "20",
        label: this.$t("fba.applyForShipment"),
      },
      {
        value: "24",
        label: this.$t("fba.badToHandle"),
      },
      {
        value: "26",
        label: this.$t("fba.badReject"),
      },
      {
        value: "28",
        label: this.$t("fba.exchangeToReturn"),
      },
      {
        value: "32",
        label: this.$t("fba.exchangeToArrival"),
      },
      {
        value: "36",
        label: this.$t("fba.toPartiallyReturned"),
      },
      {
        value: "40",
        label: this.$t("fba.reissueToArrival"),
      },
      {
        value: "44",
        label: this.$t("fba.toPay"),
      },
      {
        value: "48",
        label: this.$t("fba.toSend"),
      },
      {
        value: "52",
        label: this.$t("fba.sent"),
      },
      {
        value: "56",
        label: this.$t("fba.cancelled"),
      },
      {
        value: "60",
        label: this.$t("fba.returnApplying"),
      },
      {
        value: "64",
        label: this.$t("fba.returnToPay"),
      },
      {
        value: "68",
        label: this.$t("fba.toReturn"),
      },
      {
        value: "72",
        label: this.$t("fba.returned"),
      },
      {
        value: "76",
        label: this.$t("fba.destroyToApply"),
      },
      {
        value: "80",
        label: this.$t("fba.destroyToPay"),
      },
      {
        value: "82",
        label: this.$t("fba.fba9"),
      },
      {
        value: "84",
        label: this.$t("fba.destroyed"),
      },
      {
        value: "88",
        label: this.$t("fba.sampled"),
      },
      {
        value: "89",
        label: this.$t("fba.fba10"),
      },
    ]
    this.getStatisticalNum()
    this.getAsyncColumns().then(() => {
      this.getContainerList()
    })
    this.getDropDownList()
  },
  beforeDestroy () {
    this.clearPolling()
  },
  beforeRouteLeave (to, from, next) {
    this.saveQueryState()
    next()
  }
};
</script>
<style scoped>
.link:hover,
.server-table i.el-tooltip:hover {
  cursor: pointer;
  color: #409eff;
}

.ta-l {
  text-align: left;
}
</style>
<style lang="less" scoped>
/deep/ .el-textarea__inner {
  color: #606266 !important;
}

.search-btn {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.freight-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}

.logistics-company-row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.lx-table-wrapper {
  padding-bottom: 43px;
  box-sizing: content-box;
}

.lx-page-pagination {
  position: absolute;
  right: 0;
  bottom: 5px;
  width: 100%;
  height: 35px;
  background-color: #fff;
}

@media screen and (min-width: 1000px) and (max-width: 1550px) {
  .search-btn {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
.upload-style-custom {
  display: block;
}
.upload-style-custom /deep/ .el-upload-list {
  text-align: left;
}
.upload-style-custom /deep/ .my-upload-text-mini {
  max-width: 100%;
}
.upload-style-custom /deep/ .el-upload-list .el-upload-list__item-name {
  padding-right: 30px;
}
</style>
